import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const ITPro: Site = {
  id: 'itpro',
  logo: 'svg/itpro.svg',
  label: 'ITpro',
  analyticsName: 'itpro',
  hostname: 'itpro.com',
  platform: 'progressive',
  selector: progressiveVanillaSelector,
};
